import React from "react";
import "./styles.scss";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";

function DropDownMenu(props) {
  const { current, menuItems, item } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div role="menu">
      <Button
        className={"buttonMenu"}
        variant="outlined"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        {(current || "").replace(/_/g, " ")}
      </Button>
      <Popper
        open={!!anchorEl}
        anchorEl={anchorEl}
        role={undefined}
        transition={true}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom" ? "center top" : "center bottom",
            }}
          >
            <div>
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={false} id="menu-list-grow">
                    {menuItems?.map((menuItem) => (
                      <MenuItem
                        key={menuItem.title}
                        disabled={menuItem.disabled}
                        onClick={() => {
                          if (!menuItem.disabled) {
                            handleClose();
                            menuItem.action(item);
                          }
                        }}
                      >
                        {menuItem.title.replace(/_/g, " ")}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </div>
          </Grow>
        )}
      </Popper>
    </div>
  );
}

export default DropDownMenu;
